<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="box no-display">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Leaving Certificate </strong>
          <v-icon @click="onload" title="Reload list" dark color="yellow">mdi-reload</v-icon>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4" class="mt-3">
          <v-combobox class="no-display" v-model="registration_no" @change="checkHistory" :loading="comp_load" rounded
            :items="stud_list" label="Select Student" item-text="name" outlined dense
            prepend-icon="mdi-account-child-circle"></v-combobox>
        </v-col>
        <!-- <v-btn class="button mt-4" v-if="registration_no != null" @click="checkHistory()">Proceed</v-btn> -->
      </v-row>
      <!-- new code -->
      <div v-if="registration_no != null">
        <!-- collapse table code -->
        <template>
          <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader">Account History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-data-table :headers="headers_1" :items="ay_record" class="elevation-1 mytable" dense>
                  <template v-slot:item.status="{ item }">
                    <v-chip :color="getColor(item.status)" dark>
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
                <!-- table end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels class="expapanel no-display" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader">Academic History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <!-- table content -->

                <v-data-table :headers="headers_2" :items="ay_record_div" dense class="elevation-1 mytable">
                </v-data-table>
                <!-- table end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>

        <!-- tableData -- <br>{{ay_record}} -->
        <!-- collapse table code end -->
        <!-- radio button -->
        <v-row justify="center" dense class="no-display">
          <v-radio-group v-model="fetch_gen_toggle" mandatory row class="radiobtn">
            <v-radio label="Fetch LC" value="FETCH"></v-radio>
            <v-radio label="Generate LC" value="GENERATE"></v-radio>
          </v-radio-group>
        </v-row>
        <!-- radio button end -->
        <v-row justify="center" v-if="ay_record.length != 0">
          <!-- {{ ay_record }}<br /> -->
          <div class="fees no-display">
            <span v-if="account_status" style="color: #4caf50">Fees Clear
            </span>
            <span v-else style="color: #f44336">Fees Pending</span>
          </div>
        </v-row>
      </div>
      <!-- end dd -->
    </v-card>
    <div v-if="registration_no != null">
      <!-- shiv code -->

      <!-- shiv code end -->

      <!-- FGT:{{ fetch_gen_toggle }} -->

      <!-- generate lc code -->
      <template v-if="fetch_gen_toggle == 'GENERATE'">
        <!-- Date starts -->
        <v-row justify="center" class="mt-3">
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field dense v-model="last_date_of_school" @blur="date = parseDate(last_date_of_school)" v-on="on"
                hint="Last Date of Leaving" prepend-icon="event" persistent-hint></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
          </v-menu>

          <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field dense v-model="gen_date" @blur="date = parseDate(gen_date)" v-on="on" hint="Generation Date"
                prepend-icon="event" persistent-hint></v-text-field>
            </template>
            <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-row>
        <!-- Date ends -->
        <!-- L:{{ last_date_of_school }} -->
        <v-row justify="center" class="mt-3">
          <v-col cols="12" sm="3" md="3">
            <v-combobox v-model="progress" rounded :items="dvt_prog" label="Select Progress" outlined dense
              persistent-hint></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox v-model="conduct" rounded :items="dvt_conduct" label="Select Conduct" outlined dense
              persistent-hint></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox v-model="remark" rounded :items="dvt_remark" label="Select Remark" outlined dense
              persistent-hint></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox v-model="reason" rounded :items="dvt_reason" label="Select Reason" outlined dense
              persistent-hint></v-combobox>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-3">
          <v-checkbox color="#0f2027" v-model="mark_inactive"
            label="Do You Want To Mark Student Inactive After Generating LC.?"></v-checkbox>

        </v-row>
        <v-row justify="center">
          <v-btn @click="genLC" :disabled="!condition">Generate LC</v-btn>
        </v-row>
      </template>
      <!-- generate lc code end -->
      <template v-if="fetch_gen_toggle == 'FETCH'">
        <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>
        <!-- <v-btn
          v-if="lc_data != null"
          class="ma-2 no-display"
          tile
          outlined
          color="warning"
          @click="print()"
        >
          <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
        </v-btn> -->

        <br />
      </template>
      <!-- <div v-if="lc_data != null"> -->
      <!-- lc: {{ lc_data }}
        <br /> -->
      <!-- org: {{ org_basic_data }} -->
      <!-- lc data code -->
      <div id="document1" class="printdiv" v-if="lc_data != null">
        <div class="header">
          <div v-if="org_basic_data.school_name == 'Zeal International School'">
            <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/zeal/CBSE+LETTERHEAD.jpg" alt="" width="100%" />
            <center>
              <h2 style="text-transform: uppercase;">Leaving Certificate</h2>
            </center>
          </div>
          <div v-else>
            <div dense v-if="lc_data.Affiliation_no != null"
              style="width: 50%;display: inline-block;font-size: 14px;font-family: arial;font-weight: bolder;">
              Affiliation
              No.:&nbsp;{{ lc_data.Affiliation_no }}</div>
            <div dense v-if="lc_data.school_code != null"
              style="width: 50%;display: inline-block;font-size: 14px;font-family: arial;font-weight: bolder;text-align:right">
              School Code.:&nbsp;{{ lc_data.school_code }}</div>


            <!-- <v-row dense style="font-weight: bolder" v-if="lc_data.udise_no != null && lc_data.school_code !=null ">
            <v-col cols="12" md="4" sm="4">
              <span class="schl-info"
                >Affiliation No.:&nbsp;{{ lc_data.Affiliation_no }}</span
              >
            </v-col>
            <v-col cols="12" md="4" sm="4"></v-col>
            <v-col align="right" cols="12" md="4" sm="4"
              ><span class="schl-info"
                >School Code.:&nbsp;{{ lc_data.school_code }}</span
              ></v-col
            >
          </v-row>
          <br> -->
            <v-row dense>
              <v-col cols="12" sm="3" md="3">
                <img :src="org_basic_data.trust_logo" alt="" class="schlImg" />
                <span class="b-sapn" style="" v-if="lc_data.udise_no != null">
                  <b> UDISE No: {{ lc_data.udise_no }}</b>
                </span>
              </v-col>

              <v-col cols="12" sm="9" md="9">
                <center>
                  <h3 class="trust-name">
                    {{ org_basic_data.trust_name }}
                  </h3>
                  <h1 class="schl-name">
                    {{ org_basic_data.school_name }}
                  </h1>

                  <h3 style="text-transform: uppercase">(English Medium)</h3>
                </center>

                <center>
                  <span class="adrs h2-span">{{ org_basic_data.address }}</span><br />

                  <span class="adrs h2-span">
                    Ph.No. {{ org_basic_data.phone }}
                  </span>
                  <span class="h2-span" style="margin-left: 5px">
                    Email: {{ org_basic_data.email }}
                  </span>
                </center>
                <center>
                  <span class="line1 h2-span" v-html="org_basic_data.line1"></span><br />

                  <span class="line2 h2-span" v-html="org_basic_data.line2"></span><br />
                </center>

                <span class="stdsection h2-span">{{ lc_data.section_name }}</span><br />

                <div class="lcheading1">
                  <h3 class="lcheading stretch2">Leaving Certificate</h3>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="lcdata">
          <!-- <v-col cols="12">
          <v-row dense style="font-weight: bolder">
            <v-col cols="12" md="4" sm="4">
              <span class="schl-info"
                >Affiliation No.:&nbsp;{{ lc_data.Affiliation_no }}</span
              >
            </v-col>
            <v-col cols="12" md="4" sm="4"></v-col>
            <v-col align="right" cols="12" md="4" sm="4"
              ><span class="schl-info"
                >School Code.:&nbsp;{{ lc_data.school_code }}</span
              ></v-col
            >
          </v-row>
        </v-col> -->
          <hr />
          <br />
          <span class="h2-span" style="margin-left: 2%">
            Note:- No Change in any entry is to be made except by the authority
            issuing Certificate Infringenment of the rule will be
          </span>
          <br />
          <span class="h2-span" style="margin-left: 6%">
            punished with rustication.</span>
          <br />
          <hr />

          <v-col cols="12">
            <v-row dense style="font-weight: bolder">
              <v-col cols="12" md="4" sm="4">
                <span class="h2-span">
                  General Register No. :- {{ lc_data.gr_number }}
                </span>
              </v-col>
              <v-col cols="12" md="4" sm="4"><span class="h3-span"> Original </span></v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="h2-span">
                  Certificate No. :- {{ lc_data.certificate_no }}
                </span></v-col>
            </v-row>
          </v-col>
          <!-- <br /> -->

          <!-- lc table content  -->

          <v-col cols="12" sm="12" md="12">
            <v-simple-table id="page">
              <tbody class="tablebody">
                <tr>
                  <td>1</td>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? "Saral ID" : "Student Id" }}</td>
                  <td class="tdata2">
                    <span v-if="
                      lc_data.saral_id !== null || lc_data.saral_id !== ''
                    ">
                      {{ lc_data.saral_id }}</span>
                  </td>
                </tr>

                <tr>
                  <td>2</td>
                  <td>UID(Aadhar No)</td>
                  <td class="tdata2">{{ lc_data.aadhar_no }}</td>
                </tr>
                <tr v-if="org_basic_data.school_name === 'Zeal International School'">
                  <td>3</td>
                  <td>PEN No</td>
                  <td class="tdata2">{{ lc_data.pen_no }}</td>
                </tr>
                <tr v-if="org_basic_data.school_name === 'Zeal International School'">
                  <td>4</td>
                  <td>APAAR ID</td>
                  <td class="tdata2">{{ lc_data.apaar_id }}</td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 5 : 3 }}</td>
                  <td>Name of the pupil in full</td>
                  <td class="tdata2">{{ lc_data.fullname }}</td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 6 : 4 }}</td>
                  <td>Mother's Name</td>
                  <td class="tdata2">{{ lc_data.mother_first_name }}</td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 7 : 5 }}</td>
                  <td>Religion and Caste-Subcaste</td>
                  <td class="tdata2">
                    {{ lc_data.religion }}-{{ lc_data.caste }}
                  </td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 8 : 6 }}</td>
                  <td>Nationality</td>
                  <td class="tdata2">{{ lc_data.nationality }}</td>
                </tr>

                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 9 : 7 }}</td>
                  <td>Mother Tongue</td>
                  <td class="tdata2">{{ lc_data.mothertoungue }}</td>
                </tr>

                <tr v-if="org_basic_data.school_name === 'Zeal International School'">
                  <td>10</td>
                  <td>Date of Birth, Month & Year according to Christian Era</td>
                  <td class="tdata2">
                    {{ lc_data.dob_fig }}-{{ lc_data.dob_words }}
                  </td>
                </tr>

                <tr v-if="org_basic_data.school_name === 'Zeal International School'">
                  <td>11</td>
                  <td>Place of Birth</td>
                  <td class="tdata2">{{ lc_data.birth_place }}</td>
                </tr>
                <tr v-if="org_basic_data.school_name === 'Zeal International School'">
                  <td></td>
                  <td>Birth Taluka</td>
                  <td class="tdata2">{{ lc_data.birth_taluka }}</td>
                </tr>
                <tr v-if="org_basic_data.school_name === 'Zeal International School'">
                  <td></td>
                  <td>Birth District</td>
                  <td class="tdata2">{{ lc_data.birth_district }}</td>
                </tr>
                <tr v-if="org_basic_data.school_name === 'Zeal International School'">
                  <td></td>
                  <td>Birth State</td>
                  <td class="tdata2">{{ lc_data.birth_state }}</td>
                </tr>
                <tr v-if="org_basic_data.school_name === 'Zeal International School'">
                  <td></td>
                  <td>Birth Country</td>
                  <td class="tdata2">{{ lc_data.birth_country_new }}</td>
                </tr>

                <tr v-if="org_basic_data.school_name !== 'Zeal International School'">
                  <td>8</td>
                  <td>Place of Birth(Village,City,Tal-Dist.)</td>
                  <td class="tdata2">{{ lc_data.birth_place }}
                  </td>
                </tr>
                <tr v-if="org_basic_data.school_name !== 'Zeal International School'">
                  <td>9</td>
                  <td>Date of Birth, Month & Year according to Christian Era</td>
                  <td class="tdata2">
                    {{ lc_data.dob_fig }}-{{ lc_data.dob_words }}
                  </td>
                </tr>

                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 12 : 10 }}</td>
                  <td>Last School Attended</td>
                  <td class="tdata2">{{ lc_data.last_school }}</td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 13 : 11 }}</td>
                  <td>Date of Admission</td>
                  <td class="tdata2">{{ lc_data.doa }}</td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 14 : 12 }}</td>
                  <td>Progress</td>
                  <td class="tdata2">{{ lc_data.progress }}</td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 15 : 13 }}</td>
                  <td>Conduct</td>
                  <td class="tdata2">{{ lc_data.conduct }}</td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 16 : 14 }}</td>
                  <td>Date of Leaving School</td>
                  <td class="tdata2">{{ lc_data.last_date_of_school }}</td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 17 : 15 }}</td>
                  <td>Standard in which Studying & Since when</td>
                  <td class="tdata2">
                    {{ lc_data.standard }} and
                    {{ lc_data.standard_since_when }}
                  </td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 18 : 16 }}</td>
                  <td>Reason of Leaving School</td>
                  <td class="tdata2">{{ lc_data.reason }}</td>
                </tr>
                <tr>
                  <td>{{ org_basic_data.school_name === 'Zeal International School' ? 19 : 17 }}</td>
                  <td>Remarks</td>
                  <td class="tdata2">{{ lc_data.remark }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <!-- lc table end -->
          <span class="b2-span" style="margin-left: 15%">Certified that the above information is in accordance with the
            School Register </span><br />
          <span class="tdata2 b2-span" style="margin-left: 5px">Date :- {{ lc_data.gen_date
            }}</span><br /><br /><br /><br />
          <v-col cols="12" style="font-weight: bolder">
            <v-row dense>
              <v-col cols="12" md="4" sm="4"><span class="b2-span">Class Teacher</span>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <span class="b2-span">Clerk</span>
              </v-col>
              <v-col cols="12" md="4" sm="4">
                <center>
                  <span class="b2-span">Principal</span> <br />
                  <span class="b2-span"> {{ org_basic_data.school_name }}</span>
                </center>
              </v-col>
            </v-row>
          </v-col>
        </div>
      </div>
      <!-- lc data code end -->

      <br />
      <div v-if="lc_data != null">
        <div class="no-display" style="text-align: center">
          ----------------------------------Modify------------------------------------
        </div>
        <br />

        <v-row justify="center" class="mt-3">
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Student Progress" v-model.trim="lc_data.progress"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Conduct" v-model.trim="lc_data.conduct"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Student Remark" v-model.trim="lc_data.remark"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Student Reason" v-model.trim="lc_data.reason"></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-btn class="mb-2 button" color="warning" @click="savegenLC()" small>Save</v-btn>
        </v-row>
        <hr>
        <v-row class="no-display">
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Birth in words" v-model.trim="lc_data.dob_words"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Last School" v-model.trim="lc_data.last_school"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Standard" v-model.trim="lc_data.standard"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Since when..." v-model.trim="lc_data.standard_since_when"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Caste" v-model.trim="lc_data.caste"></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Religion" v-model.trim="lc_data.religion"></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-btn @click="proceed" class="info">Proceed to print</v-btn>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      mark_inactive: false,
      headers_1: [
        { text: "Academic Year", value: "ay" },
        { text: "Paid", value: "paid" },
        { text: "Balance", value: "balance" },
        { text: "Status", value: "status" },
      ],
      headers_2: [
        { text: "Academic Year", value: "ay" },
        { text: "Roll No", value: "rollno" },
        { text: "Div", value: "div" },
        { text: "Std", value: "std" },
        { text: "Total", value: "total" },
        { text: "Present ", value: "present" },
      ],

      comp_load: false,
      fetch_loader: false,
      overlay: false,
      snackbar: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      registration_no: null,
      stud_list: [],
      ay_record: [],
      ay_record_div: [],
      account_status: false,
      dvt_prog: [],
      progress: null,
      dvt_conduct: [],
      conduct: null,
      dvt_reason: [],
      reason: null,
      dvt_remark: [],
      remark: null,
      fetch_gen_toggle: "FETCH",
      //////date
      last_date_of_school: "",
      gen_date: "",
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      nowDate: new Date().toISOString().slice(0, 10),
      ///
      lc_data: null,
      org_basic_data: null,
      condition: false,
    };
  },
  watch: {
    date(val) {
      this.last_date_of_school = this.formatDate(this.date);
    },
    date2(val) {
      this.gen_date = this.formatDate(this.date2);
    },
  },
  methods: {
    savegenLC() {
      const formData = {
        lid: this.registration_no.lid,
        progress: this.lc_data.progress,
        conduct: this.lc_data.conduct,
        remark: this.lc_data.remark,
        reason: this.lc_data.reason,
      };
      this.overlay = true;
      axios
        .post("/certificate/genLC", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            // this.lc_data.last_school = this.org_basic_data.school_name;
            this.showSnackbar("green", "Success..!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    proceed() {
      localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
      localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
      let routeData = this.$router.resolve({ name: "zeal-lc-print" });
      window.open(routeData.href, "_blank");
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },

    // row_classes(item) {
    //     console.log("in function row");
    //     const rowClass = 'redrow'
    //     if (item.status === "pending" )
    //     return rowClass
    //     if(item.status === "clear")
    //     return "green"

    // },

    //     row_classes: function (item) {
    //         console.log("in fu");
    //     return item.status === 'pending' ? 'style-1' : 'style-2'

    // },

    getColor(status) {
      if (status === "pending") return "red";
      if (status === "clear") return "green";
      if (status === "NA") return "gray";
    },

    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onload() {
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.all_stud_list;
          } else {
            this.showSnackbar("red", "Something went wrong.");
          }
          this.comp_load = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.comp_load = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    checkHistory() {
      console.log("registration_no:", this.registration_no);
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      if (this.registration_no == null) {
        this.showSnackbar("red", "Please select student");
      }
      this.overlay = true;
      axios
        .post("/certificate/checkHistory", this.registration_no)
        .then((res) => {
          console.log("res", res.data);
          if (res.data.flag == "YES") {
            this.ay_record = res.data.ay_record;
            this.account_status = res.data.account_status;
            this.ay_record_div = res.data.ay_record_div;
            this.dvt_prog = res.data.dvt_prog;
            this.progress = this.dvt_prog[0];
            this.dvt_conduct = res.data.dvt_conduct;
            this.conduct = this.dvt_conduct[0];
            this.dvt_reason = res.data.dvt_reason;
            this.reason = this.dvt_reason[0];
            this.dvt_remark = res.data.dvt_remark;
            this.remark = this.dvt_remark[0];
            this.condition = res.data.condition;
            if (!this.condition)
              this.showSnackbar("red", res.data.condition_msg);
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    genLC() {
      if (this.account_status == false) {
        if (
          !confirm(
            "Are You Sure You Want To generate LC as fees is pending...?"
          )
        )
          return;
      }
      if (
        this.progress != null &&
        this.conduct != null &&
        this.last_date_of_school != "" &&
        this.gen_date != "" &&
        this.remark != null &&
        this.reason != null
      ) {
        const formData = {
          lid: this.registration_no.lid,
          progress: this.progress,
          conduct: this.conduct,
          remark: this.remark,
          reason: this.reason,
          last_date_of_school: this.last_date_of_school,
          gen_date: this.gen_date,
          mark_inactive: this.mark_inactive
        };
        this.overlay = true;
        axios
          .post("/certificate/genLC", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.org_basic_data = res.data.org_basic_data;
              this.lc_data = res.data.lc_data;
              // this.lc_data.last_school = this.org_basic_data.school_name;
              // if (this.lc_data.caste == null) {
              //   alert("Caste is not enter ..");
              // }
              // this.showSnackbar("green", "User data fetched!!!");
            } else {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.overlay = false;
          })
          .catch((error) => {
            this.onerror(error);

            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.showSnackbar("red", "Please select/enter all data");
      }
    },
    fetchLC() {
      this.overlay = true;
      axios
        .post("/certificate/fetchLC", this.registration_no)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            // this.lc_data.last_school = this.org_basic_data.school_name;
            // this.showSnackbar("green", "User data fetched!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    localStorage.setItem("lc_data", null);
    localStorage.setItem("org_basic_data", null);
    localStorage.setItem("last_date_of_school", "")
    this.onload();
    this.last_date_of_school = this.formatDate(this.date);
    this.gen_date = this.formatDate(this.date2);
  },
};
</script>
<style scoped>
.scroll {
  overflow-x: scroll;
}

.mytable1 /deep/ thead th {
  background: #0f2027 !important;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027) !important;
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027) !important;
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}

.mytable /deep/ thead th {
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
  background: #83a4d4;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #265fb1,
      #b6fbff);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #265fb1,
      #b6fbff);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}

tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}

td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}

/* @media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
} */
/* v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: medium;
} */

.expapanel {
  width: 93%;
  margin-left: 3%;
}

.panelheader {
  /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
  color: white !important;
  background: #83a4d4;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #3792c7,
      #60e3eb,
      #a0dfe3);
  /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-size: 16px;
  background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}

.fees span {
  font-size: 23px;
  font-weight: 600;
}

/* .radiobtn{
  display: inline !important;
} */

/* lc data css */
.printdiv {
  border: 3px solid;
  border-color: black;
  height: auto;
  /* width: 944px; */
  /* margin-left: 5%; */
  /* margin-top: 5px; */
  width: auto;
  margin-left: 5%;
  margin-right: 5%;
}

.header {
  /* border:2px solid;  */
  margin: 6px;
}

.trust-name {
  /* margin-left: 22%; */
  text-transform: uppercase;
}

.schl-name {
  font-size: 30px;
  text-transform: uppercase;
}

.adrs {
  /* margin-left: 33px; */
  margin-left: -10%;
}

.line1 {
  margin-left: -10%;
}

.line2 {
  margin-left: -10%;
}

.stdsection {
  margin-left: 30%;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 15px;
}

.b-sapn {
  font-weight: 500;
  margin-left: 18px;
  font-size: 14px;
  display: block;
  margin-top: 2px;
}

.lcheading {
  /* border-block: 1px solid black; */
  border: 1px solid black;

  /* display: block; */
  /* width: 26%; */
  /* border-left: 1px solid black; */
  /* border-right: 1px solid black; */
  /* margin-left: 30%; */
  font-size: 17px;
  font-weight: 600;
  padding-left: 5px;
  padding-right: 5px;
  text-transform: uppercase;
}

.lcheading1 {
  margin-left: 26%;
  width: 28%;
  text-align: center;
}

.schlImg {
  /* width: 196px;
        height: 196px; */
  width: 87%;
  height: 60%;
  margin-left: 10px;
}

.tdata2 {
  font-weight: bolder;
}

#page tr,
td {
  /* padding: 0;  */
  /* margin-left: 0px; */
  font-size: large;
  text-align: left;
}

/* lc data css end */

/* print lc css */
@media print {
  .b-sapn {
    font-weight: 500;
    /* margin-left: 15px; */
    font-size: 21px;
  }

  .schl-name {
    font-size: 35px;
    text-transform: uppercase;
  }

  .b2-span {
    font-weight: 500;
    margin-left: 18px;
    font-size: x-large;
  }

  .h3-span {
    /* margin-left: 15px; */
    font-size: 30px;
  }

  .h2-span {
    font-size: larger;
  }

  .card {
    border: none !important;
    font-size: large !important;
  }

  .pagebreak {
    page-break-before: always;
  }

  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  body,
  tr,
  th,
  td {
    font-size: x-large !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  v-card {
    border: none !important;
  }

  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    /* size: 11.5in 17.5in; */

    size: 15in 15in;
    /* size: 10in 18in; */

    /* size: 10in 17in; */
  }

  /* thead {
    font-weight: bold !important;
  } */
  /* table,
  tr,
  th {
    text-align: center !important;
    margin-top: none;
    padding: none !important;
    border-bottom: 1px solid black;
    border: 1px solid black;
  } */
}

/* print lc css end */

.style-1 {
  background-color: rgb(215, 84, 44);
  font-weight: bolder;
}

.style-2 {
  background-color: rgb(61, 219, 21);
}

span.stretch {
  display: inline-block;
  -webkit-transform: scale(1.5, 1);
  /* Safari and Chrome */
  -moz-transform: scale(1.3, 1);
  /* Firefox */
  -ms-transform: scale(1.5, 1);
  /* IE 9 */
  -o-transform: scale(1.5, 1);
  /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}

.stretch1 {
  display: inline-block;
  -webkit-transform: scale(1.3, 1);
  /* Safari and Chrome */
  -moz-transform: scale(1.3, 1);
  /* Firefox */
  -ms-transform: scale(1.5, 1);
  /* IE 9 */
  -o-transform: scale(1.5, 1);
  /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}

h3.stretch2 {
  display: inline-block;
  -webkit-transform: scale(2, 1);
  /* Safari and Chrome */
  -moz-transform: scale(1.5, 1);
  /* Firefox */
  -ms-transform: scale(1.5, 1);
  /* IE 9 */
  -o-transform: scale(1.5, 1);
  /* Opera */
}
</style>
